import { Redirect, useRouteMatch } from 'react-router';
import { Switch } from 'react-router-dom';
import { GroupListTableView } from './table/GroupListTable';
import { PageNotFound } from 'features/main/components/CustomErrorPages';
import { ApmRoute } from '@elastic/apm-rum-react';
import { GroupListDetails } from 'features/user-group/user-group-details/components/GroupListDetails';

const GroupListContainer = () => {
  const { path } = useRouteMatch();

  return (
    <>
      <Switch>
        <ApmRoute
          exact
          path={path}
          component={() => <Redirect to={`${path}/page/1`} />}
        />
        <ApmRoute
          path={`${path}/page/:page`}
          render={(props) => <GroupListTableView {...props} />}
        />
        <ApmRoute
          exact
          path={`${path}/:id/:tab/page/:page`}
          render={(props) => <GroupListDetails {...props} />}
        />
        <ApmRoute
          path={`${path}/:id/:tab`}
          render={(props) => <GroupListDetails {...props} />}
        />
        <ApmRoute component={PageNotFound} />
      </Switch>
    </>
  );
};

export default GroupListContainer;
